import React from 'react';
import { fmtRM } from '../../data/mockData';

export function PriceDisplay({ price, original, size = 'md' }) {
  const sizes = { sm: 'text-sm', md: 'text-base', lg: 'text-2xl' };
  return (
    <div className="flex items-baseline gap-2" data-testid="price-display">
      <span className={`font-semibold text-kelate-darkwood ${sizes[size]}`}>{fmtRM(price)}</span>
      {original && original > price && (
        <span className="text-xs text-kelate-soft line-through">{fmtRM(original)}</span>
      )}
    </div>
  );
}
